import useElementScrollInfo from 'hooks/useElementScrollInfo'
import { useVariableLoadedListener } from 'hooks/useVariableLoadedListener'
import { useEffect, useRef, useState } from 'react'
import { animate } from 'utils/scroll'

export const useScrollControl = () => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  const { scroll, elementRef } = useElementScrollInfo('horizontal')

  const scrollElement = useVariableLoadedListener(() => {
    elementRef.current = containerRef?.current
    return containerRef?.current
  }, [containerRef])

  const scrollRight = () => {
    animate('scrollLeft', scrollElement, scrollElement.scrollLeft + scrollElement.clientWidth)
  }

  const scrollLeft = () => {
    animate('scrollLeft', scrollElement, scrollElement.scrollLeft - scrollElement.clientWidth)
  }

  return {
    containerRef,
    scrollRight,
    scrollLeft,
    scroll,
  }
}

export const useDetectScroll = (containerRef: React.RefObject<HTMLElement | null>) => {
  const [isScrollable, setIsScrollable] = useState(false)

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    const checkScrollable = () => {
      const { scrollWidth, clientWidth } = el
      setIsScrollable(scrollWidth > clientWidth)
    }

    const observer = new ResizeObserver(checkScrollable)
    observer.observe(el)

    checkScrollable()

    return () => {
      observer.disconnect()
    }
  }, [])

  return isScrollable
}
